import { LocationCountByLocationType, PlanContainerLocationCount } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count";
import { PlanContainerLocationCountWebEntity } from "./plan-contianer-location-count-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";
import { LocationCountByLocationTypeWebRepositoryMapper } from "./location-count-web-repository-mapper";
import { LocationCountByLocationTypeWebEntity } from "./location-count-web-entity";
import { PlanContainerLocationCountByProductWebEntity } from "./plan-container-location-count-by-product-web-entity";
import { LocationCountByProduct, PlanContainerLocationCountByProduct } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count-by-product";
import { LocationCountByProductWebRepositoryMapper } from "./location-count-by-product-web-repository-mapper";
import { LocationCountByProductWebEntity } from "./location-count-by-product-web-entity";

export class PlanContainerLocationCountByProductWebRepositoryMapper extends Mapper<
PlanContainerLocationCountByProductWebEntity,
PlanContainerLocationCountByProduct
> {
  constructor() {
    super();
  }

  mapFrom(param: PlanContainerLocationCountByProductWebEntity): PlanContainerLocationCountByProduct {
    const locationCountList: LocationCountByProduct[] = [];
    const locationCountMapper = new LocationCountByProductWebRepositoryMapper();
    param.locationsCount?.forEach((locationCount) => {
      const mappedLocation = locationCountMapper.mapFrom(locationCount);
      locationCountList.push(mappedLocation);
    });
    return {
      locationsCount: locationCountList,
      totalNoOfLocations: param.totalNoOfLocations
    };
  }

  mapTo(param: PlanContainerLocationCountByProduct): PlanContainerLocationCountByProductWebEntity {
    const locationCountWebEntityList: LocationCountByProductWebEntity[] = [];
    const locationCountMapper = new LocationCountByProductWebRepositoryMapper();
    param.locationsCount?.forEach((locationCount) => {
      const mappedLocation = locationCountMapper.mapTo(locationCount);
      locationCountWebEntityList.push(mappedLocation);
    });
    return {
      locationsCount:locationCountWebEntityList,
      totalNoOfLocations:param.totalNoOfLocations
    };
  }
}
